import {
  useWishlist,
} from "../context/WishlistContext-plus";

export default function Wishlist() {
  const {
    wishlist,
    removeWishlist,
  } = useWishlist();

  return (
    <div className="page">
      <h2>Wishlist</h2>

      {wishlist.map((item) => (
        <div
          key={item.id}
          className="cart-item"
        >
          <h4>{item.name}</h4>

          <button
            onClick={() =>
              removeWishlist(item.id)
            }
          >
            Remove
          </button>
        </div>
      ))}
    </div>
  );
}